import { useState } from 'react';
import { Box, Typography, Stack, TextField, Snackbar, Alert } from '@mui/material';
import { navigate, nextParam } from '../../lib/navigation';
import AuthPageLayout from '../../components/AuthPageLayout';
import Button from '../../components/Button';
import FloatingHelpButton from '../../components/FloatingHelpButton';

function SignupPage({ authActions }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const next = nextParam();

  async function submit(event) {
    event.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    setSubmitting(true);
    try {
      await authActions.signup(email, password);
      navigate(next || '/onboarding');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthPageLayout variant="signup">
      <Typography variant="h4" fontWeight={700} sx={{ fontSize: '1.75rem', mb: 0.75 }}>
        Sign up
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Get your profile ready now so you can respond quickly when the right UGC opportunity arrives.
      </Typography>
      <Box component="form" onSubmit={submit}>
        <Stack spacing={2}>
          <TextField fullWidth label="Email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required autoComplete="email" />
          <TextField
            fullWidth
            label="Password"
            type="password"
            helperText="At least 8 characters"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            autoComplete="new-password"
          />
          <Button type="submit" disabled={submitting} sx={{ py: 1.25 }}>
            {submitting ? 'Creating your CreatorCV…' : 'Create my CreatorCV'}
          </Button>
        </Stack>
      </Box>
      {next === '/claim' && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          You'll be able to enter your claim code right after this.
        </Typography>
      )}
      <Typography sx={{ mt: 3 }} color="text.secondary">
        Already have an account?{' '}
        <Box
          component="span"
          sx={{ color: 'primary.main', cursor: 'pointer', fontWeight: 600 }}
          onClick={() => navigate(`/login${next ? `?next=${encodeURIComponent(next)}` : ''}`)}
        >
          Log in
        </Box>
      </Typography>
      <Snackbar
        open={Boolean(error)}
        autoHideDuration={4000}
        onClose={() => setError('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setError('')} severity="error" variant="filled" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      <FloatingHelpButton />
    </AuthPageLayout>
  );
}

export default SignupPage;
